<div class="topaz-modal">
    <div class="topaz-modal-content">
        <div class="topaz-modal-header">
            <span class="topaz-close">&times;</span>
            <h4>Topaz Settings</h4>
        </div>
        <br />
        <div class="topaz-modal-body" *ngIf="!isInstalled">
            <img src="assets/Img/RedCheck.png">
            <span>SigWeb is either not installed or running, Please Install the <a href="https://www.topazsystems.com/software/sigweb.exe">SigWeb.exe</a> File! </span>
        </div>    

        <div class="topaz-modal-body" *ngIf="isInstalled">
            <img src="assets/Img/GreenCheck.png">
                <span>SigWeb is installed and running successfully!</span>
        </div>

        <br />
    </div>
</div> 